// src/pages/termOfPayments/TermOfPayments.jsx
import React from "react";
import WrapperSection from "../../components/global/WrapperSection";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import TermOfPaymentsTable from "../../components/termOfPayments/TermOfPaymentsTable";

const TermOfPayments = () => {
    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <TermOfPaymentsTable />
        </WrapperSection>
    );
};

export default TermOfPayments;